// Messages visitors send through the contact form on the masjid's website.
import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const messages = createApi({
  reducerPath: "messages",
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ["Messages"],
  endpoints: (builder) => ({
    // status: undefined = inbox (everything not archived), or "new" / "read" / "archived".
    getMessages: builder.query({
      query: ({ status, page = 1 } = {}) => {
        const params = new URLSearchParams({ page: String(page) });
        if (status) params.set("status", status);
        return `/api/messages?${params}`;
      },
      providesTags: ["Messages"],
    }),
    updateMessage: builder.mutation({
      query: ({ id, status }) => ({ url: `/api/messages/${id}`, method: "PATCH", body: { status } }),
      invalidatesTags: ["Messages"],
    }),
    deleteMessage: builder.mutation({
      query: (id) => ({ url: `/api/messages/${id}`, method: "DELETE" }),
      invalidatesTags: ["Messages"],
    }),
  }),
});

export const { useGetMessagesQuery, useUpdateMessageMutation, useDeleteMessageMutation } = messages;
